// src/components/JsonLd.jsx
//
// Tiny wrapper that renders a <script type="application/ld+json">
// element for a stringified JSON-LD payload. Centralizes the
// dangerouslySetInnerHTML pattern that was previously inlined at
// every call site (CityPage, StatePage).
//
// Usage:
//   <JsonLd payload={articleSchema(fm, authorSlug)} />
//   {/* multiple */}
//   {[articleSchema(fm, slug), breadcrumbSchema(crumbs)]
//      .filter(Boolean)
//      .map((p, i) => <JsonLd key={i} payload={p} />)}

import React from 'react';

export default function JsonLd({ payload }) {
  if (!payload) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: payload }}
    />
  );
}
